module.exports = __webpack_public_path__ + "img/achiote_grill_logo_small.5883d885.png";